import {createFileRoute, SearchSchemaInput} from '@tanstack/react-router';

import FinishProfileView from '../user/FinishProfileView.tsx';

export const Route = createFileRoute('/finish-profile')({
    validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
        token: typeof search.token === 'string' ? search.token : '',
    }),
    component: RouteComponent,
});

function RouteComponent() {
    const {token} = Route.useSearch();

    return <FinishProfileView token={token} />;
}
